import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { getServiceMonthlyReport } from '@/modules/Report/components/ServiceMonthlyReport/services'
import ServicesTrendChart from '@/modules/Report/components/ServiceMonthlyReport/components/ServicesTrendChart'
import { Skeleton } from '@/components/ui/skeleton'
import dayjs from 'dayjs'
import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const ServiceTrendWidget: React.FC = () => {
    const currentYear = dayjs().year()

    // Fetch current year data
    const { data: currentYearData, isLoading } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.REPORTS_BI_SERVICE_MONTHLY, currentYear],
        queryFn: () => getServiceMonthlyReport({ year: currentYear }),
    })

    // Fetch previous year data for comparison
    const { data: previousYearData } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.REPORTS_BI_SERVICE_MONTHLY, currentYear - 1],
        queryFn: () => getServiceMonthlyReport({ year: currentYear - 1 }),
    })

    if (isLoading) {
        return (
            <div className="bg-white rounded-md p-4 shadow-sm border border-gray-100">
                <Skeleton className="h-6 w-48 mb-2" />
                <Skeleton className="h-4 w-32 mb-4" />
                <Skeleton className="h-[350px] w-full" />
            </div>
        )
    }

    return (
        <ServicesTrendChart
            data={currentYearData || []}
            previousYearData={previousYearData}
            showComparison={!!previousYearData?.length}
            year={currentYear}
        />
    )
}

export default ServiceTrendWidget
